import React from "react";
import BookingRoomType from "../BookingRoomType";
import BookingSearchOptions from "../BookingSearchOptions";
import BookingFlowTotal from "../BookingFlowTotal";

export default class BookingAccommodationsTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded_room_type_id: null,
    };
  }

  render() {
    if (this.props.room_types) {
      var room_types = this.props.room_types
        .map( (room_type, idx) => {
          if (room_type.number_of_available_rooms > 0) {
            return <BookingRoomType
              bookingFlowRef={this.props.bookingFlowRef}
              expanded_room_type_id={this.state.expanded_room_type_id}
              highlighted_room_type_id={this.props.highlighted_room_type_id}
              currency={this.props.currency}
              start_date={this.props.start_date}
              end_date={this.props.end_date}
              room_type={room_type}
              guests={this.props.guests}
              key={room_type.id}
              number_format={this.props.number_format}
              onAddReservationSegment={this.props.onAddReservationSegment}
              onModalVisible={this.props.onModalVisible}
              finalRoomType={idx === this.props.room_types.length - 1}
              inquiry_room_type_id={this.props.inquiry_room_type_id}
            />
          }
        });
    }
    return (
      <div className="BookingAccommodationsTab">
        {this.renderErrors()}
        <BookingSearchOptions
          {...this.props}
          onChangeDates={this.props.onChangeDates}
        />
        <div className="row">
         
          <div
            className={
              this.props.totalComponent || this.props.continueButton
                ? "col-sm-7 booking-products-wrapper"
                : "col-sm-12"
            }        
            style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100% - 56px)",
              }}
          >
          
            {room_types && room_types.length > 0 ? (
              <div className="BookingRoomTypes">{room_types}</div>
            ) : (
              this.renderNoRoomsMessage()
            )}
            {!this.props.loading && (
              <div className="check-availability-wrapper">
                <a href="#" onClick={this.props.onToggleCheckAvailability}>
                  {I18n.t("show_availability_calendar")}
                </a>
              </div>
            )}
          </div>

          {this.props.totalComponent || this.props.continueButton ? (
            <div className="col-sm-5 booking-total-summary-wrapper">
              <div className="BookingTotal"><BookingFlowTotal {...this.props} /></div>             
            </div>
          ) : null}

        </div>

      </div>
    );
  }

  renderErrors() {
    if (this.props.errors && this.props.errors.length > 0) {
      var errors = this.props.errors.map(function (error) {
        if (error == I18n.t("one_or_more_rooms_is_no_longer_available")) {
          return <li key={error}>{error}</li>;
        }
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderNoRoomsMessage() {
    if (!this.props.loading) {
      return (
        <div className="jumbotron" style={{ marginTop: "15px" }}>
          <div className="row">
            <div className="col-sm-12">
              <div className="no-rooms-available">
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.props.no_availability_text,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
